import React, {useEffect, useState} from "react";
import TopBoxV2 from "../common/TopBoxV2";
import PageNameV2 from "../common/PageNameV2";
import PageTitleV2 from "../common/PageTitleV2";
import ShopSelectBoxV2 from "../common/ShopSelectBoxV2";
import {DataPicker1} from "../../picker/DataPicker1";
import {
  formatCost, getChecked,
  getParameter,
  getValue,
  openPopup,
  setChecked,
  setValue
} from "../../../static/js/Common2";
import {useShopCouponList} from "../../../static/js/hock/couponHock";
import {deleteCoupon, getCouponDetail, getShopCouponListApi} from "../../../static/js/service/couponService";
import {pagingBtn, pagingBtn2, subNavEvent} from "../../../static/js/service/commonService";
import CouponPopupV2 from "./CouponPopupV2";
import excelIcon from "../../../static/image/v2/excel.png";
import checkBox1 from "../../../static/image/v2/check1.png";
import checkBox2 from "../../../static/image/v2/check2.png";
import newCouponIcon from "../../../static/image/v2/newCoupon.png";
import * as XLSX from "xlsx";
import {callLoadingEvent} from "../../../utils/CommonUtils";
import {ReactComponent as Bar} from "../../../assets/images/bar.svg";
import {useShopAdminDetail2} from "../../../static/js/hock/shopHock";

export default function CouponListV2() {
  const [shopId, setShopId] = useState();
  const [list, setList] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [checkActive, setCheckActive] = useState(false);
  const [approvalTpcd1, setApprovalTpcd1] = useState();
  const page = getParameter("page") === null ? 1 : Number(getParameter("page"));
  const searchType = getParameter("searchType") === null ? 1 : Number(getParameter("searchType"));
  const searchText = getParameter("text") === null ? "" : getParameter("text");
  const startDate = getParameter("startDate");
  const endDate = getParameter("endDate");
  const status = getParameter("status") === null ? 0 : Number(getParameter("status"));

  let data;
  if (shopId) {
    data = {
      page: page,
      count: 10,
      shopId: shopId
    };

    if (searchText !== "") {
      data.keyword = searchText;
      data.searchType = searchType;
    }
    if (startDate && endDate) {
      data.startDate = startDate;
      data.endDate = endDate;
    }
    if (status !== 0) {
      data.status = status;
    }
  }

  useShopCouponList({setList, setTotalPage, setTotalCount}, data);
  useShopAdminDetail2({setApprovalTpcd1}, shopId);

  useEffect(() => {
    if(list.length > 0) {
      pagingBtn(page, totalPage, `/v2/coupon?${urlLink()}`);
    }
    subNavEvent("manageNav", "manage2");
  }, [list]);

  const urlLink = () => {
    const searchType = getValue("searchSelect1");
    const text = getValue("searchTextInput");
    const startDate = getValue("startDate");
    const status = getValue("searchSelect2");

    return `searchType=${searchType}&text=${text}&startDate=${startDate}&status=${status}`;
  };

  // 검색
  function searchBtn() {
    let searchSelect1 = document.getElementById("searchSelect1");
    let searchSelect2 = document.getElementById("searchSelect2");

    let getSearchType =  Number(searchSelect1.options[searchSelect1.selectedIndex].value);
    let getStatus =  Number(searchSelect2.options[searchSelect2.selectedIndex].value);
    let getStartDate = getValue("startDate");
    let getEndDate = getValue("endDate");
    let getSearchText = getValue("searchTextInput")

    window.location.href = `/v2/coupon?shopSelect=${shopId}&text=${getSearchText}&startDate=${getStartDate}&endDate=${getEndDate}&status=${getStatus}&page=${page}&searchType=${getSearchType}`;
  }

  // 쿠폰 리스트
let couponListBox = list.map((value, index) => {
  console.log(value)
  let couponStatus = "진행";
  let couponClass = "blue";

  if (Number(value.status) === 2) {
    couponStatus = "일시종료";
    couponClass = "orange";
  } else if (Number(value.status) === 3) {
    couponStatus = "종료";
    couponClass = "gray";
  }

  return (
    <div className="tableBodyV2" key={index} onClick={() => couponDetail(value.id)}>
      {checkActive &&
        <div className='width100 d-flex a-center j-center'>
          <input type="checkbox" id={`checkBox${value.id}`} className="checkbox" value={value.id}/>
          <label htmlFor={`checkBox${value.id}`}></label>
        </div>
      }
      <div className="width170">{value.name}</div>
      <div className="width100">{value.createDateTime.substring(2,10)}</div>
      <div className="width170">{value.issuedStartDateTime.substring(2,10)} ~ {value.issuedEndDateTime.substring(2,10)}</div>
      <div className="width80">{value.availableDays}</div>
      <div className="width130">{formatCost(value.discountCost)}원</div>
      <div className="width130">{formatCost(value.minOrderCost)}원</div>
      <div className="width100">{formatCost(value.remainCount)}</div>
      <div className="width100">{formatCost(value.issuedCount)}</div>
      <div className={`width110 states ${couponClass}`}>{couponStatus}</div>
      <div className="width110">
        {Number(value.issuerType) !== 1 &&
          <button onClick={(e) => {
            e.stopPropagation();
            deleteCoupon(value);
          }}>삭제</button>
        }
      </div>
    </div>
  );
});
  
  // 쿠폰 상세 조회
  function couponDetail(id) {
    if (checkActive) {
      setChecked(`checkBox${id}`, !getChecked(`checkBox${id}`));
    } else {
      getCouponDetail(id).then((response) => {
        let data = response;

      // ! 본사 발행 쿠폰 수정 차단
      if (Number(data.issuerType) === 1) {
        alert("본사에서 발급한 쿠폰은 수정할 수 없습니다.");
        return;
      }

        let deliType = data.deliveryTypeList.length === 2 ? 0 : data.deliveryTypeList[0];

        setValue("couponId2", id);
        setValue("name2", data.name);
        setValue("state2", data.couponStatus);
        setValue("couponCost2", data.discountCost);
        setValue("couponMinCost2", data.minOrderCost);
        setValue("issuedCount2", data.issuedCount);
        setValue("couponCount2", data.remainCount);
        setValue("startDate2", data.issuedStartDateTime.substring(0, 10));
        setValue("endDate2", data.issuedEndDateTime.substring(0, 10));
        setValue("couponUseTime2", data.availableDays);

        document.querySelectorAll(`input[name='deliType2'][value='${deliType}']`).forEach(radio => {
          radio.checked = true;
        });

        openPopup("modiCouponPopup");
      });
    }
  }

  const allCheckEvent = () => {
    const checkbox = document.querySelectorAll(".checkbox");
    checkbox.forEach((element) => {
      element.checked = true;
    });
  };

  const excelDownEvent = async () => {
    callLoadingEvent(1);
    let excelList = [];
    let currentPage = 1;
    let pageSize = 50;

    if (!checkActive) pageSize = 50;

    const excelSearchData = {
      page: currentPage,
      count: pageSize,
      shopId: shopId
    };

    if (searchText) {
      excelSearchData.keyword = searchText;
      excelSearchData.searchType = searchType;
    }
    if (startDate && endDate) {
      excelSearchData.startDate = startDate;
      excelSearchData.endDate = endDate;
    }
    if (status !== 0) {
      excelSearchData.status = status;
    }

    if (!checkActive) {
      let hasNextPage = true;

      // 1초 대기하는 함수
      const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

      // 다음 페이지가 있을 때까지 데이터를 계속 가져옴
      while (hasNextPage) {
        // 페이지 번호를 업데이트하여 API 호출
        excelSearchData.page = currentPage;

        // API 호출
        const getData = await getShopCouponListApi(excelSearchData);

        // 데이터를 excelList에 추가
        excelList = [...excelList, ...getData.data];

        // 다음 페이지가 있는지 확인
        if (getData.data.length < pageSize) {
          hasNextPage = false; // 데이터 개수가 페이지 크기보다 적으면 마지막 페이지
        } else {
          currentPage++; // 다음 페이지로 이동
        }

        // 1초 대기
        await delay(1000);
      }

      downloadExcel(excelList);
    } else {
      let valueList = [];
      let checkBoxList = document.querySelectorAll(".checkbox");
      checkBoxList.forEach((element) => {
        if (element.checked) {
          let getValue = element.getAttribute("value");
          valueList.push(Number(getValue));
        }
      });

      const filterData = list.filter(item => valueList.includes(Number(item.id)));
      downloadExcel(filterData);
    }
  };

  const couponStatusName = (status) => {
    let statusName = "진행";
    if (status === 2) {
      statusName = "일시종료";
    } else if (status === 3) {
      statusName = "종료";
    }

    return statusName;
  }
  const downloadExcel = (data) => {
    const formatData = data.map(item => ({
      "쿠폰명": item.name,
      "등록일시": item.createDateTime.substring(2,10),
      "발급기간": `${item.issuedStartDateTime.substring(2,10)} ~ ${item.issuedEndDateTime.substring(2,10)}`,
      "사용기간": item.availableDays,
      "할인금액": `${formatCost(item.discountCost)}원`,
      "최소주문금액": `${formatCost(item.minOrderCost)}원`,
      "남은수량": `${formatCost(item.remainCount)}`,
      "발급수량": `${formatCost(item.issuedCount)}`,
      "상태": couponStatusName(item.couponStatus)
    }));

    // 엑셀 시트 생성
    const worksheet = XLSX.utils.json_to_sheet(formatData);
    const workbook = XLSX.utils.book_new();

    // 워크북에 시트 추가
    XLSX.utils.book_append_sheet(workbook, worksheet, 'CouponList');

    // 엑셀 파일 생성 및 다운로드
    XLSX.writeFile(workbook, 'couponList.xlsx');
    callLoadingEvent(2);
  }

  return (
    <>
      <section id="loadingPopup" className="popup d-none a-center j-center">
        <div className="loadingio-spinner-rolling-10rx3c6i88xj">
          <div className="ldio-5sgltw2ts33">
            <div></div>
          </div>
        </div>
      </section>
      <main id="CouponListV2" className="mainV2">
        <TopBoxV2 navGrp="manageNav" navName="manage2" />
        <CouponPopupV2 shopId={shopId} />

        <div className="container">
          <section className="containerInner">
            <PageNameV2 title1="운영 관리" title2="쿠폰 관리" />
            <div className="pageTitle mb-10 d-flex a-center j-between">
              <PageTitleV2 title="쿠폰 관리" countText="" count="" unit="" />
            </div>
            <div className="topMenu">
              <div id="shopSelectBox">
                <ShopSelectBoxV2 url="/v2/coupon" setShopId={setShopId} />
              </div>
            </div>
            <div className="topMenu">
              <div className="selectBox a-center j-left">
                <DataPicker1 id="startDate" day={startDate ? new Date(startDate) : null} />
                <span className="mr-5">~</span>
                <DataPicker1 id="endDate" day={endDate ? new Date(endDate) : null} />
                <Bar className="ml-5 mr-10" />
                <select id="searchSelect2" className="searchSelect searchSelect2 select2 width100" defaultValue={status}>
                  <option value={0}>전체</option>
                  <option value={1}>진행</option>
                  <option value={2}>일시정지</option>
                  <option value={3}>종료</option>
                </select>
                <Bar className="ml-5 mr-10" />
                <select id="searchSelect1" className="searchSelect searchSelect1 select2 width100" defaultValue={searchType}>
                  <option value={1}>쿠폰명</option>
                  <option value={2}>할인금액</option>
                </select>
                <input type="text" id="searchTextInput" className="searchTextInput marginRight5" defaultValue={searchText} maxLength={20} placeholder="검색어 입력" />
                <button type="button" id="searchBtn" className="commonBtn blueBtn width90 marginLeft5 mr-5" onClick={searchBtn}>검색</button>
              </div>
            </div>
            <div className="d-flex a-center j-between mb-15">
              <p>총 <span className="fw-7 fc-blue">{totalCount.toLocaleString()}</span>개</p>
              {approvalTpcd1 === 4 &&
                <div className="d-flex a-center j-right">
                  <button className="commonBtn d-flex a-center j-center excelBtn" onClick={excelDownEvent}>
                    <img className="icon" src={excelIcon} alt="엑셀 다운받기"/>
                    엑셀 다운받기
                  </button>
                  <button
                    className={`checkActiveBtn commonBtn marginLeft5 d-flex a-center j-center ${checkActive ? "active" : ""}`}
                    onClick={() => setCheckActive(!checkActive)}
                  >
                    <img className="icon" src={checkActive ? checkBox1 : checkBox2} alt="선택하기"/>
                    선택하기
                  </button>
                  {!checkActive &&
                    <button
                      className="commonBtn blueBtn marginLeft5 d-flex a-center j-center newBtn"
                      onClick={() => openPopup("newCouponPopup")}
                    >
                      <img className="icon" src={newCouponIcon} alt="쿠폰 등록"/>
                      쿠폰 등록
                    </button>
                  }
                </div>
              }
            </div>
            <div className="tableBoxV2">
              <div className="tableHeadV2">
                {checkActive &&
                  <div className="width100">
                    <button className="d-flex a-center j-center none" onClick={allCheckEvent}>
                      <img className="icon" src={checkBox1} alt="전체선택" />
                      전체선택
                    </button>
                  </div>
                }
                <div className="width170">쿠폰명</div>
                <div className="width100">등록일시</div>
                <div className="width170">발급기간</div>
                <div className="width80">사용기간</div>
                <div className="width130">할인금액</div>
                <div className="width130">최소주문금액</div>
                <div className="width100">남은수량</div>
                <div className="width100">발급수량</div>
                <div className="width110">상태</div>
                <div className="width110">기능</div>
              </div>
              {couponListBox}
            </div>
            <div id="pagingBox">
              <ul id="pagingList" className="d-flex a-center j-center">

              </ul>
            </div>
          </section>
        </div>
      </main>
    </>
  )
}